import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { To, useNavigate } from "react-router-dom";
import { Fab } from "../../common/components/Fab";
import { CyPlaylistFooterMenu } from "../CyPlaylistFooterMenu";
import { useTranslation } from "react-i18next";

interface Props {
  to: To;
}

export function NewEntryFab({ to }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Fab onClick={() => navigate(to)} data-cy={CyPlaylistFooterMenu.ButtonAdd}>
      <FontAwesomeIcon icon={faCirclePlus} /> {t("common.buttons.add")}
    </Fab>
  );
}
